(() => {
  const CART_ICON =
    'https://cdn.shopify.com/s/files/1/0204/3176/5568/files/shopping-cart.png';
  const ARROW_ICON =
    'https://cdn.shopify.com/s/files/1/0204/3176/5568/files/right-arrow-icon.png?v=1766873435';

  // Only the main product ATC area (prevents related/collection buttons)
  const SELECTOR = '.product-form--atc span.atc-button--text';

  function enhanceSpan(span) {
    if (!span || span.nodeType !== 1) return;
    if (span.dataset.atcEnhanced === '1') return;

    span.dataset.atcEnhanced = '1';
    span.textContent = 'Order now';

    const btn = span.closest('button.product-form--atc-button');
    if (!btn) return;

    // CART ICON (before text)
    if (!btn.querySelector('img.atc-cart-icon')) {
      const cart = document.createElement('img');
      cart.src = CART_ICON;
      cart.alt = 'Cart';
      cart.className = 'atc-cart-icon';
      cart.width = 16;
      cart.height = 16;
      cart.loading = 'lazy';
      cart.style.verticalAlign = 'middle';
      cart.style.marginRight = '8px';
      span.insertAdjacentElement('beforebegin', cart);
    }

    // ARROW ICON (after text)
    if (!btn.querySelector('img.atc-arrow-icon')) {
      const arrow = document.createElement('img');
      arrow.src = ARROW_ICON;
      arrow.alt = 'Arrow';
      arrow.className = 'atc-arrow-icon';
      arrow.width = 14;
      arrow.height = 14;
      arrow.loading = 'lazy';
      arrow.style.verticalAlign = 'middle';
      arrow.style.marginLeft = '8px';
      span.insertAdjacentElement('afterend', arrow);
    }
  }

  function initialRun() {
    document.querySelectorAll(SELECTOR).forEach(enhanceSpan);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initialRun();

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;

          // only process spans inside .product-form--atc
          if (node.matches?.(SELECTOR)) enhanceSpan(node);
          node.querySelectorAll?.(SELECTOR).forEach(enhanceSpan);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
